import {
    useActivationGaMappingDetailQuery,
    type IUseActivationGaMappingDetailQueryOptions,
} from "./useActivationGaMappingDetailQuery";

export const useActivationGaMappingState = (
    activationId: string,
    options: IUseActivationGaMappingDetailQueryOptions,
) => {
    const { data, isLoading: isMappingLoading } = useActivationGaMappingDetailQuery(activationId, options);

    return {
        hasGaMapping: !!data,
        isMappingStateFaulty: data?.state === "Faulty",
        isMappingLoading,
        mappingState: data?.state,
    };
};
